import React from 'react';
import {Icon, getTheme} from '@fluentui/react';
import useSubOrganizationScope from '../../hooks/useSubOrganizationScope';

interface ISubOrganizationScopeNoticeProps {
    /** Verb phrase describing what is scoped, e.g. "Installing for". */
    action: string;
    /** Extra guidance rendered under the headline. */
    detail?: string;
    style?: React.CSSProperties;
}

/**
 * Prominent banner naming the sub-organization a flow is about to act on. Used wherever acting under
 * the wrong customer scope would be expensive to undo, first of all the extension install flow.
 * Renders nothing when the whole organization is in scope.
 */
export const SubOrganizationScopeNotice: React.FC<ISubOrganizationScopeNoticeProps> = (props) => {
    const scope = useSubOrganizationScope();
    const theme = getTheme();

    if (!scope.isScoped) return null;

    return (
        <div
            data-testid='sub-organization-scope-notice'
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5em',
                padding: '0.5em 1em',
                marginBottom: '1em',
                borderLeft: `4px solid ${theme.palette.themePrimary}`,
                backgroundColor: theme.palette.themeLighter,
                ...props.style,
            }}
        >
            <Icon iconName='ContactInfo' style={{fontSize: '18px', color: theme.palette.themeDark}} />
            <div>
                <div style={{fontWeight: 600}}>{props.action} {scope.selectedName}</div>
                {props.detail && <div style={{fontSize: '90%'}}>{props.detail}</div>}
            </div>
        </div>
    );
};

export default SubOrganizationScopeNotice;
